import { render } from "./CompanySettings.vue?vue&type=template&id=391d1c2c&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=391d1c2c&scoped=true&lang=css&external"
import "./CompanySettings.vue?vue&type=style&index=1&id=391d1c2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391d1c2c"]])

export default __exports__